export enum StaffImpactLanguage {
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  PO = 'po',
}
export const STAFF_IMPACT_LANGUAGES = [
  { value: StaffImpactLanguage.EN, label_en: 'English', label_fr: 'Anglais' },
  { value: StaffImpactLanguage.FR, label_en: 'French', label_fr: 'Francais' },
  { value: StaffImpactLanguage.ES, label_en: 'Spanish', label_fr: 'Espagnol' },
  { value: StaffImpactLanguage.PO, label_en: 'Polish', label_fr: 'Polonaise' },
]

export enum StaffImpactAccompanyStatus {
  SINGLE = 'single-position',
  ACCOMPANIED = 'accompanied-position',
}
export const STAFF_IMPACT_ACCOMPANY_STATUSES = [
  { value: StaffImpactAccompanyStatus.SINGLE, label_en: 'Single position', label_fr: 'Position non accompagnée' },
  { value: StaffImpactAccompanyStatus.ACCOMPANIED, label_en: 'Accompanied position', label_fr: 'Position accompagnée' },
]

export enum StaffImpactExitFlag {
  OK = 'ok',
  TO_PLAN = 'to_plan',
  ENDING = 'ending',
  EXIT = 'exit',
  MOBILITY = 'mobility',
}
export const STAFF_IMPACT_EXIT_FLAGS = [
  { value: StaffImpactExitFlag.OK, label_en: 'OK', label_fr: 'OK' },
  { value: StaffImpactExitFlag.TO_PLAN, label_en: 'To plan', label_fr: 'À planifier' },
  { value: StaffImpactExitFlag.ENDING, label_en: 'Ending', label_fr: 'À terminer' },
  { value: StaffImpactExitFlag.EXIT, label_en: 'Exit', label_fr: 'À sortir' },
  { value: StaffImpactExitFlag.MOBILITY, label_en: 'Mobility', label_fr: 'Mobilité' },
]

export enum StaffImpactState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ERROR_AZURE = 'error_azure',
}
export const STAFF_IMPACT_STATES = [
  { value: StaffImpactState.ACTIVE, label_en: 'Active', label_fr: 'Actif', severity: 'success' },
  { value: StaffImpactState.INACTIVE, label_en: 'Inactive', label_fr: 'Inactif', severity: 'warn' },
  { value: StaffImpactState.ERROR_AZURE, label_en: 'Error (Azure)', label_fr: 'Erreur (Azure)', severity: 'danger' },
]

export enum StaffImpactTransition {
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  ERROR = 'error',
}
export const STAFF_IMPACT_TRANSITIONS = [
  { value: StaffImpactTransition.ACTIVATE, label_en: 'Activate', label_fr: 'Activer' },
  { value: StaffImpactTransition.DEACTIVATE, label_en: 'Deactivate', label_fr: 'Désactiver' },
  { value: StaffImpactTransition.ERROR, label_en: 'Error', label_fr: 'Erreur' },
]

export enum StaffImpactEmploymentType {
  INTERN = 'intern',
  EMPLOYER_OF_RECORD = 'employer-of-record',
  SALARIED = 'salaried',
}
export const STAFF_IMPACT_EMPLOYMENT_TYPES = [
  { value: StaffImpactEmploymentType.INTERN, label_en: 'Intern', label_fr: 'Stagaire' },
  { value: StaffImpactEmploymentType.EMPLOYER_OF_RECORD, label_en: 'Employer of record', label_fr: 'Employer of record' },
  { value: StaffImpactEmploymentType.SALARIED, label_en: 'Salaried', label_fr: 'Salarié' },
]

export enum StaffImpactEmployer {
  IMPACT = 'impact',
  ACTED = 'acted',
}
export const STAFF_IMPACT_EMPLOYERS = [
  { value: StaffImpactEmployer.IMPACT, label_en: 'IMPACT', label_fr: 'IMPACT' },
  { value: StaffImpactEmployer.ACTED, label_en: 'Acted', label_fr: 'Acted' },
]

export enum StaffImpactReasonLeaving {
  VOLUNTARY = 'voluntary',
  NON_VOLUNTARY = 'non_voluntary',
}
export const STAFF_IMPACT_REASONS_LEAVING = [
  { value: StaffImpactReasonLeaving.VOLUNTARY, label_en: 'Voluntary', label_fr: 'Volontaire' },
  { value: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Non voluntary', label_fr: 'Non volontaire' },
]

export enum StaffImpactJustification {
  OTHER_JOB_OPPORTUNITIES = 'other_job_opportunities',
  CAREER_GROWTH = 'career_growth',
  PERSONAL = 'personal',
  MANAGEMENT_ISSUES = 'management_issues',
  ORGANIZATIONAL_CULTURE = 'organizational_culture',
  CULTURE_DIFFERENCES = 'culture_differences',
  WORKLOAD = 'workload',
  COMPENSATION_BENEFITS = 'compensation_benefits',
  UNDERPERFORMANCE = 'underperformance',
  MISCONDUCT = 'misconduct',
  POLICY_VIOLATIONS = 'policy_violations',
  REDUNDANCY = 'redundancy',
  RESTRUCTURATION = 'restructuration',
  PROBATION_FAILURE = 'probation_failure',
  END_OF_INTERNSHIP = 'end_of_internship',
  MOVE_TO_NATIONAL_CONTRACT = 'move_to_national_contract',
  NO_MATCHING_POSITION_FOUND = 'no_matching_position_found',
  LACK_OF_FUNDING = 'lack_of_funding',
}
export const STAFF_IMPACT_JUSTIFICATIONS = [
  {
    value: StaffImpactJustification.OTHER_JOB_OPPORTUNITIES,
    category: StaffImpactReasonLeaving.VOLUNTARY,
    label_en: 'Other job opportunities',
    label_fr: 'Autres opportunités professionnelles',
  },
  { value: StaffImpactJustification.CAREER_GROWTH, category: StaffImpactReasonLeaving.VOLUNTARY, label_en: 'Career growth', label_fr: 'Évolution de carrière' },
  {
    value: StaffImpactJustification.PERSONAL,
    category: StaffImpactReasonLeaving.VOLUNTARY,
    label_en: 'Personal (Relocation, Family, Health)',
    label_fr: 'Personnel (Déménagement, Famille, Santé)',
  },
  { value: StaffImpactJustification.MANAGEMENT_ISSUES, category: StaffImpactReasonLeaving.VOLUNTARY, label_en: 'Management issues', label_fr: 'Problèmes de management' },
  {
    value: StaffImpactJustification.ORGANIZATIONAL_CULTURE,
    category: StaffImpactReasonLeaving.VOLUNTARY,
    label_en: 'Organizational culture',
    label_fr: 'Culture organisationnelle',
  },
  { value: StaffImpactJustification.CULTURE_DIFFERENCES, category: StaffImpactReasonLeaving.VOLUNTARY, label_en: 'Culture differences', label_fr: 'Différences culturelles' },
  { value: StaffImpactJustification.WORKLOAD, category: StaffImpactReasonLeaving.VOLUNTARY, label_en: 'Workload', label_fr: 'Charge de travail' },
  {
    value: StaffImpactJustification.COMPENSATION_BENEFITS,
    category: StaffImpactReasonLeaving.VOLUNTARY,
    label_en: 'Compensation & Benefits',
    label_fr: 'Rémunération et avantages',
  },
  { value: StaffImpactJustification.UNDERPERFORMANCE, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Underperformance', label_fr: 'Sous-performance' },
  { value: StaffImpactJustification.MISCONDUCT, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Misconduct', label_fr: 'Faute professionnelle' },
  { value: StaffImpactJustification.POLICY_VIOLATIONS, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Policy violations', label_fr: 'Non-respect des politiques' },
  { value: StaffImpactJustification.REDUNDANCY, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Redundancy', label_fr: 'Suppression de poste' },
  { value: StaffImpactJustification.RESTRUCTURATION, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Restructuration', label_fr: 'Restructuration' },
  { value: StaffImpactJustification.PROBATION_FAILURE, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Probation failure', label_fr: 'Échec de la période d’essai' },
  { value: StaffImpactJustification.END_OF_INTERNSHIP, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'End of internship', label_fr: 'Fin de stage' },
  {
    value: StaffImpactJustification.MOVE_TO_NATIONAL_CONTRACT,
    category: StaffImpactReasonLeaving.NON_VOLUNTARY,
    label_en: 'Move to national contract',
    label_fr: 'Passage à un contrat national',
  },
  {
    value: StaffImpactJustification.NO_MATCHING_POSITION_FOUND,
    category: StaffImpactReasonLeaving.NON_VOLUNTARY,
    label_en: 'No matching position found',
    label_fr: 'Aucun poste correspondant trouvé',
  },
  { value: StaffImpactJustification.LACK_OF_FUNDING, category: StaffImpactReasonLeaving.NON_VOLUNTARY, label_en: 'Lack of funding', label_fr: 'Manque de financement' },
]
